import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText } from 'lucide-react';
const includes = [{
  title: 'Manual "Clave de Paz" (30 páginas)',
  desc: 'Guía paso a paso para desmantelar el conflicto digital.'
}, {
  title: 'Protocolos de Gestión de Crisis',
  desc: 'Qué hacer y qué NO hacer cuando el mensaje es un ataque directo.'
}, {
  title: 'El Semáforo de la Respuesta',
  desc: 'Cómo clasificar cada texto en 3 segundos para saber si merece tu tiempo. 🔴🟡🟢'
}, {
  title: 'Técnicas de "Desconexión de Cortisol"',
  desc: 'Cómo bajar las pulsaciones antes de tocar el teclado.'
}, {
  title: 'Fórmulas de Respuesta Logística',
  desc: 'Cómo armar tus propios mensajes BIFF (Breves, Informativos, Firmes y Fríos).'
}, {
  title: 'Límites Innegociables',
  desc: 'Cómo establecer horarios y canales de comunicación que se respeten.'
}];
export function WhatYouGet() {
  return <section className="bg-navy py-24 px-6" data-id="element-299">
      <div className="max-w-3xl mx-auto" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center md:text-left" data-id="element-301">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-302">
            <FileText size={14} data-id="element-303" />
            Todo en formato PDF · Descarga inmediata
          </div>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-304">
            Qué incluye tu manual
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-305">
          {includes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-slate-200 flex items-start gap-4" data-id="element-306">
              <div className="flex-shrink-0 mt-0.5" data-id="element-307">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-308" />
              </div>
              <div data-id="element-309">
                <h4 className="text-navy font-bold text-lg mb-1 leading-tight" data-id="element-310">
                  {item.title}
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-311">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}